<template>
    <div class="electrictiy-bill-calculator__read-more">
        <button type="button" class="is-collapsed electrictiy-bill-calculator__read-more-button" :aria-controls="elementId" @click="isOpen = !isOpen" :aria-expanded="isOpen">
            <span>{{buttonText ? buttonText : 'Läs mer'}}</span> <span :class="[isOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down']"></span>
        </button>         
		<div :id="elementId" class="electrictiy-bill-calculator__read-more-body" :aria-hidden="!isOpen">
            <div class="electrictiy-bill-calculator__read-more-body-inner-wrapper">
                <slot></slot>                  
            </div>
		</div>
	</div>
</template>


<script setup>
    import { ref } from 'vue';
    
    const props = defineProps({
        buttonText: { type: String, required: false },        
        elementId: { type: String, required: true },        
    });

    const isOpen = ref(false);
    
</script>



<style scoped>

</style>
